import { PaymentMethod } from "core/store/billing";

import { emitGooglePayButtonClick, emitApplePayButtonClick } from "../utils/buttons";

export const NATIVE_PAYMENT: Partial<Record<PaymentMethod, (args: Record<string, any>) => void>> = {
  applepay: emitApplePayButtonClick,
  googlepay: emitGooglePayButtonClick,
};

export const ERROR_CODES = {
  INSUFFICIENT_FUNDS: '302',
} as const;

export const generalCategory = 'onetime_purchase';

export const PAYMENT_MODES = {
  NATIVE_MODAL: 'native+modal',
  NATIVE: 'native',
  MODAL: 'modal',
} as const;
